module.exports = __webpack_public_path__ + "img/33852-116.ef48cb3e.jpg";